import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import {
  LandingPage,
  AdminUsersPage,
  OnboardingPage,
  CallbackPage,
  Dashboard,
  AnalysisDetailPage,
  InvestmentThesisPage,
  CompaniesPage,
  CompanyDetailsPage,
  NotificationsPage,
  SettingsPage,
  ProfilePage,
  PrivacyPolicyPage,
  TermsOfUsePage,
} from './pages';
import MainLayout from './layouts/MainLayout';
import { useUserData } from './hooks/useUserData';

const RequireAuth: React.FC = () => {
  const { isLoading, isAuthenticated } = useUserData();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

const RequireAdmin: React.FC = () => {
  const { isLoading, isAuthenticated, user } = useUserData();
  const isAdmin = Boolean(user?.groups?.includes('ADMIN'));

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
          <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/callback" element={<CallbackPage />} />

          {/* Rotas Protegidas com Layout Principal */}
          <Route element={<MainLayout />}>
            <Route element={<RequireAdmin />}>
              <Route path="/admin/usuarios" element={<AdminUsersPage />} />
            </Route>
            <Route element={<RequireAuth />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/analise/:analysisId" element={<AnalysisDetailPage />} />
              <Route path="/teses-investimento" element={<InvestmentThesisPage />} />
              <Route path="/empresas" element={<CompaniesPage />} />
              <Route path="/empresas/:ticker" element={<CompanyDetailsPage />} />
              <Route path="/configuracoes" element={<SettingsPage />} />
              <Route path="/notificacoes" element={<NotificationsPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
            </Route>
          </Route>

          {/* Redirecionamento para rotas não encontradas */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


